import { createdStyledElement } from "~/sharedComponents/layout/createdStyledElement";

/**
 * Just shortcut for <Box display="flex" />
 */
export const Flex = createdStyledElement({
    name: "Flex",
    defaultCssProps: { display: "flex" },
});

/**
 *  Creates an adjustable, empty space that can be used to tune the spacing between child elements within.
 *
 *  For example if there are 3 elements inside the flex and the last one should be shown at the right corner then
 *  just add <Spacer> before the 3rd element.
 *  <Flex>
 *      <Button />
 *      <Button />
 *      <Spacer />
 *      <Button />
 *  </Flex>
 */
export const Spacer = createdStyledElement({
    name: "Spacer",
    defaultCssProps: { flex: "1 0" },
});

/**
 * Centers its child within itself.
 */
export const Center = createdStyledElement({
    name: "Center",
    defaultCssProps: { display: "flex", alignItems: "center", justifyContent: "center" },
});
